import axios, { account } from "../../config/axios";
// import setTokenToHeader from "../setTokenToHeader";
// import val from "../../getThemeDetails";

import {
  REGENERATE_SECKEY_NOT_AVAILABLE,
  REGENERATE_SECKEY_INVALID_TOKEN,
  REGENERATE_SECKEY_WRONG_PASSWORD,
  REGENERATE_SECKEY_SUCCESS,
  RESET_REGENERATE_SECKEY,
  NETWORK_ERROR_REGENERATE_SECKEY,
} from "../types";

const resetRegSecKey = () => {
  return {
    type: RESET_REGENERATE_SECKEY,
  };
};

const regenerateSecKey = (userData) => async (dispatch) => {
  console.log(userData);
  await account
    .post("getSecretKey", userData)
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(success(res.data));
          break;

        case "Wrong Password":
          dispatch(wrong_password(res.data));
          break;

        case "Invalid token":
          dispatch(invalid_token(res.data));
          break;

        case "Not available":
          dispatch(not_available(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      dispatch({
        type: NETWORK_ERROR_REGENERATE_SECKEY,
        payload: err,
      })
    );
};

function not_available(data) {
  return {
    type: REGENERATE_SECKEY_NOT_AVAILABLE,
    payload: data,
  };
}

function wrong_password(data) {
  return {
    type: REGENERATE_SECKEY_WRONG_PASSWORD,
    payload: data,
  };
}

function invalid_token(data) {
  return {
    type: REGENERATE_SECKEY_INVALID_TOKEN,
    payload: data,
  };
}

function success(data) {
  return {
    type: REGENERATE_SECKEY_SUCCESS,
    payload: data,
  };
}

export { regenerateSecKey, resetRegSecKey };
